import React, { useEffect, useRef, useState,useContext } from "react";
import ThemeControls from "../../AllThemesControl";
import '../css/header.css'
import { SideMenuJson } from '../../../modules/menu'
import { MasterContext } from "../../../services/MasterContext";
import { MdKeyboardArrowRight, MdMenu } from "react-icons/md";
import ProfileMenu from '../../Profile';
import {
  useNavigate
} from "react-router-dom";
import { NavLink } from 'react-router-dom';
import Profile from "../../Profile";
export default function Header(props) {
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  let navigate = useNavigate();
  const [inactive, setInactive] = useState(false);
  const ref = useRef();
  const [index, setIndex] = React.useState();
  const [childIndex, setChildIndex] = React.useState();
  const [childsIndex, setChildsIndex] = React.useState();
  const [listOpen, setListOpen] = React.useState(false);
  const [menuJson,setMenuJson]=React.useState(SideMenuJson)
  const Name = localStorage.getItem('name');
  const userName = localStorage.getItem('userName');
  const { userRole } = useContext(MasterContext);
  function getFirstLetter(str) {
    return str.charAt(0);
  }
  function splitString(str) {
    return str.split(' ')[0];
}
  const firstLetter = getFirstLetter(Name?Name:'');
  const firstName = splitString(Name?Name:'');


  useEffect(() => {
    function updateAuth(menuItems, contextPermissions) {
      menuItems.forEach(item => {
        const permissions = userRole?.data?.filter(permission => permission.applicationcontext === item.roleContext);
        if (permissions && permissions.length > 0) {
          for (const permission of permissions) {
              if (permission.accessPersmission === 1) {
                item.auth = true;
              }
          }
      }
        if (item.items) {
          updateAuth(item.items, contextPermissions);
        }
      });
    }
    
    // Create a deep copy of the menu JSON to avoid mutating the original state directly
    const updatedMenuJson = JSON.parse(JSON.stringify(menuJson));
    
    // Update the auth properties based on userRole data
    updateAuth(updatedMenuJson.menus[0].item, userRole?.data);

    // Update the state with the modified menu JSON
    setMenuJson(updatedMenuJson);
  }, [userRole]);

//console.log(menuJson)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setInactive(false);
        // setListOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const removeToken = () => {
    window.localStorage.clear();
    window.location.reload(false);
  };

  const ChangePassword = () => {
    navigate("/changePassword");
  };
const newTabeOpen=(link)=>{
  window.open(link, "_blank");
}
  const menuRoutes = (link, list) => {
    navigate(link);
    localStorage.removeItem('filterValue');
    if (list) {
      setListOpen(current => !current)
    } else {
      setListOpen(false)
    }
  }
  const menuRoutesChild = (link) => {
    navigate(link);
    localStorage.removeItem('filterValue');
    setListOpen(false)
    setIndex()
    setChildsIndex()
    setChildIndex()
  }

  function account() {
    // alert("Account")
    setInactive(current => !current)
    setListOpen(false)
  }

  const handleMouseEnter = (index) => {
    setIndex(index)
  };

  const handleMouseLeave = () => {
    setIndex()
  };
  const handleMouseEnter1 = (index) => {
    setChildIndex(index)
  };

  const handleMouseLeave1 = () => {
    setChildIndex()
  };
  const handleMouseEnter2 = (index) => {
    setChildsIndex(index)
  };

  const handleMouseLeave2 = () => {
    setChildsIndex()
  };


  return (

    <div id="app">
      <div className="header">
        <div className="wrapper">
          <div className="header-logo">
            {/* <img src={Logo} alt="logo" /> */}
            {/* <h3>Freezecrowd</h3> */}
          </div>
          <div className="app-nav hide-on-mobile">
            {menuJson?.menus.map((menu, _i) => (
              <div key={menu.MenuTitle} className="menu-ht">
                {menu.item.map((item, i) => (
                  ////console.log(_i),
                  item.auth&&<NavLink
                    to={item.path}
                    key={item.title}
                    className={(index === i) ? 'router-link-exact-active router-link-active' : ''}
                    aria-current="page"
                    onMouseEnter={() => handleMouseEnter(i)} onMouseLeave={handleMouseLeave}
                  >
                    <span onClick={() => { menuRoutes(item.path, item.items); setIndex(i) }}>{item.title}</span>
                    {item.items && (
                      <div className={(index === i) ? "db dropdown-nav reports-dropdown" : "dropdown-nav reports-dropdown"}>
                        <div id="reports_triangle" className="triangle" />
                        <ul className="list-flat dropdown-nav-list">
                          {item.items.map((childItem, _childIndex) => (
                            childItem.auth&&<li key={childItem.title} onMouseEnter={() => handleMouseEnter1(_childIndex)} onMouseLeave={handleMouseLeave1}>
                              <NavLink to={childItem.path} onClick={() => { menuRoutesChild(childItem.path)}}  className="">
                                <span>{childItem.title}</span>
                                {childItem.items && (<MdKeyboardArrowRight />)}
                              </NavLink>
                              {childItem.items && (
                                <div className={(childIndex === _childIndex) ? "db  sidenav dropdown-nav reports-dropdown" : "dropdown-nav reports-dropdown"}>
                                  <div id="reports_triangle" className="left-triangle" />
                                  <ul className="list-flat dropdown-nav-list">
                                    {childItem.items.map((childItems, _childsIndex) => (
                                      childItems.auth&&<li key={childItems.title} onMouseEnter={() => handleMouseEnter2(_childsIndex)} onMouseLeave={handleMouseLeave2}>
                                        <NavLink to={childItems.path} onClick={() => { menuRoutesChild(childItems.path) }}  className="">
                                          <span>{childItems.title}</span>
                                          {childItems.items && (<MdKeyboardArrowRight />)}
                                        </NavLink>
                                        {childItems.items && (
                                          <div className={(childsIndex === _childsIndex) ? "db sidenav dropdown-nav reports-dropdown" : "dropdown-nav reports-dropdown"}>
                                            <div id="reports_triangle" className="left-triangle" />
                                            <ul className="list-flat dropdown-nav-list">
                                              {childItems.items.map((lastItem) => (
                                                lastItem.auth&&<li key={lastItem.title}>
                                                  <NavLink to={lastItem.path} onClick={() => { menuRoutesChild(lastItem.path) }}  className="">
                                                    <span>{lastItem.title}</span>
                                                  </NavLink>
                                                </li>
                                              ))}
                                            </ul>
                                          </div>
                                        )}
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              )}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </NavLink>
                ))}
              </div>
            ))}

          </div>
          <div className="right-nav hide-on-mobile" ref={ref}>
            <div className="user-nav perspective ">
              <a className="dropdown-label user-id"onClick={account}>
                <div id="avatar-17" className="profile-avatar">
                  <div
                    className="avatarji"
                  >
                    <span>{firstLetter}</span>
                  </div>
                </div>
                <span id="userDetails" name="">
                {firstName}
                </span>
              </a>
              {/* <div className={inactive ? "db dropdown-nav" : "dropdown-nav"}>
                <div className="triangle" />
                <div className="dropdown-nav-header">
                  <a className="">
                    <span className="username">{userName}</span>
                  </a>
                </div>
                <hr />
                <ul className="list-flat dropdown-nav-list">
                  <li>
                    <a className="">
                      <span className="icon icon-user" /> My account{" "}
                    </a>
                  </li>
                  <hr />
                  <li>
                    <a className="">
                      Signin Another Account
                    </a>
                  </li>
                  <hr />
                  <li onClick={ChangePassword}>
                    <a
                      target="_blank"
                    >
                      <span className="icon icon-help-circle" /> Change Password
                    </a>
                  </li>
                  <hr />
                  <li onClick={removeToken}>
                    <a target="_self" href="#" >
                      <span className="icon icon-exit" /> Logout
                    </a>
                  </li>
                </ul>
              </div> */}
              {inactive&&<ProfileMenu inactive={inactive}/>}
            </div>
          </div>
          <div className="show-on-mobile">
            <MdMenu onClick={props.sideMenuOpen}/>
          </div>
        </div>
      </div>
    </div>


  )
}